import { Circle } from '@mui/icons-material'
import React from 'react'
import { R } from '../../../R/R'
import { MVPButton, MVPButtonProps } from '../../Buttons/MVPButton'
import { WalletMenu } from './WalletMenu'
import './WalletButton.scss'

interface Props extends MVPButtonProps
{
	moneyAmount: string,
	showIndicator: boolean
}

export const WalletButton = ({ moneyAmount, showIndicator,  ...buttonProps } : Props) =>
{
	return (
		<div id='wallet-container'>
			<MVPButton id='wallet-button' className='clear' {...buttonProps}>
				<img src={R.images.iconChip} alt='chip icon' />
				<h3 id='wallet-label'>${moneyAmount}</h3>
				{showIndicator && <Circle className='indicator' color='error'/>}
			</MVPButton>
			<WalletMenu />
		</div>
	)
}
